import { ResourceQueryService } from '@lib/common-sdk';
import { BreadcrumbDataQuery } from '@lib/ui-components';

export const CommuneBreadcrumbProvider: BreadcrumbDataQuery = {
  fetchFunction(id: string): () => Promise<any> {
    return function () {
      return ResourceQueryService.findOne<any>(`/api/resource/communes/${parseInt(id)}`);
    };
  },

  mapToBreadcrumb(data: any): string {
    return data.name;
  },

  query: 'communes',
};
